/*@ngInject*/
angular.module('gw-um-grid-data-browser', [
    'umCore'
])
    .constant('gridDataBrowserConstant', {
        event: {
            BULK_ACTION_COMPLETE: 'gridDataBrowserModule.BulkActionComplete'
        }
    })
    .run(() => {
    });

require('./gridDataBrowserComponent.js');

module.exports = 'gw-um-grid-data-browser';
